import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonCheckboxComponent } from '@shared/components/common-checkbox/common-checkbox.component';
// import { CommonCheckboxComponent } from '../../../../../common-checkbox/common-checkbox.component';

@Component({
  selector: 'app-dcf-common-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CommonCheckboxComponent],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DcfCommonCheckboxComponent), multi: true }],
  template: `
    <app-common-checkbox
      [label]="fieldSchema?.label || 'Checkbox'"
      [checked]="value"
      [disabled]="disabled"
      (checkedChange)="onCheckboxChange($event)">
    </app-common-checkbox>
  `
})
export class DcfCommonCheckboxComponent implements ControlValueAccessor {
  @Input() fieldSchema: any;
  @Input() formControl!: FormControl;

  value: boolean = false;
  disabled: boolean = false;

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  onCheckboxChange(checked: boolean): void {
    this.value = checked;
    this.onChange(checked);
    this.onTouched();
  }

  writeValue(value: boolean): void {
    this.value = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
